import { render, staticRenderFns } from "./HeaderSponsorPortable.vue?vue&type=template&id=645c2e32"
import script from "./HeaderSponsorPortable.vue?vue&type=script&lang=js"
export * from "./HeaderSponsorPortable.vue?vue&type=script&lang=js"
import style0 from "./HeaderSponsorPortable.vue?vue&type=style&index=0&id=645c2e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports